import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RadioButtonOption } from '../radio-button-option';

@Component({
  selector: 'yat-radio-button',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.scss']
})
export class RadioButtonComponent {
  @Output()
  toggleChanged: EventEmitter<RadioButtonOption> = new EventEmitter<RadioButtonOption>();

  @Input()
  options: RadioButtonOption[];

  @Input()
  selectedOption: RadioButtonOption;

  @Input()
  disabled: boolean = false;

  onRadioButtonChange(option: RadioButtonOption): void {
    this.selectedOption = option;
    this.toggleChanged.emit(option);
  }
}
